<section class="col-xs-12 cart_titlesection cartsectionuk" >
    <div *ngIf="enablePage.showukCartBanner">
    <div class="col-xs-12 mycartsection">
        <div class="cart_header">My Cart</div>
    </div>
    </div>
</section>
<div class="row">
    <div class=" col-12 PibannerUk"><a class="pibannerlink" href="/prescribinginformation">Prescribing Information <img alt="Next screen" src="/assets/images/arrow-right-white.svg"></a></div>
</div>